var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.061,
    height: 15.198,
    viewBox: "0 0 55.061 15.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upi-ar21_1_",
    "data-name": "upi-ar21 (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3134",
    "data-name": "Path 3134",
    d: "M95.678,30.955l7.886-7.194-3.735-7.442Z",
    transform: "translate(-48.503 -16.253)",
    fill: "#474747",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3135",
    "data-name": "Path 3135",
    d: "M90.854,30.955l7.886-7.194L95,16.319Z",
    transform: "translate(-46.335 -16.253)",
    fill: "#474747",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3136",
    "data-name": "Path 3136",
    d: "M16.834,16.348l-3.32,11.824,11.787.083,3.238-11.907h2.988L27.644,30.191a1.389,1.389,0,0,1-1.264.958H11.272a1.191,1.191,0,0,1-1.211-1.6l3.7-13.2Zm36.441-.083h2.988L52.112,31.149H49.04Zm-21.416,6.2L46.8,22.384l1-3.142H32.606l.913-2.894L49.707,16.2a1.305,1.305,0,0,1,1.342,1.744l-1.525,5.574a2.525,2.525,0,0,1-2.307,1.76H33.851L32.275,31.4H29.368Z",
    transform: "translate(-10.001 -16.199)",
    fill: "#474747",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpi);
export default __webpack_public_path__ + "static/media/upi.d01991c229a6d1b3b8e87305b53ba196.svg";
export { ForwardRef as ReactComponent };